import React from "react";
import { Link } from "react-router-dom";
import PolicyLayout, { EmailLink, policyLinks } from "./PolicyLayout";

const descriptions = {
  "/privacy": "What we collect, why we use it, who receives it, and how long we keep it.",
  "/data-choices": "How to request access, correction, deletion, portability, or other privacy choices.",
  "/cookies": "The browser storage used by this store and the controls available to you.",
  "/terms": "The main terms that apply when you browse the site or buy from tunrisefield.",
  "/orders": "Order acceptance, changes, cancellations, stock issues, and delayed fulfillment.",
  "/payments": "Currency, payment authorization, security checks, refunds, and charge disputes.",
  "/pricing": "Prices, sales tax, import duties, currency conversion, and pricing corrections.",
  "/shipping": "Processing estimates, tracking, delivery, customs, delays, and lost parcels.",
  "/returns": "Return eligibility, withdrawal rights, damaged items, exchanges, and refunds.",
  "/warranty": "Defect support, legal guarantees, exclusions, and how to make a claim.",
  "/product-safety": "Safe use, ink and stationery care, incident reports, and product recalls.",
  "/promotions": "Discount codes, sale offers, bundles, pre-orders, and promotion corrections.",
  "/acceptable-use": "Rules that protect the store, customers, and third-party rights.",
  "/intellectual-property": "Original content, permitted use, non-affiliation, and rights reports.",
  "/accessibility": "Our accessibility approach and how to report a barrier or request support.",
  "/complaints": "A clear route for order complaints, escalation, and legally available remedies.",
  "/site-notice": "Accuracy, external links, product presentation, and website availability.",
};

function PolicyIndex() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <PolicyLayout
      title="store policy center"
      intro="Clear information about shopping with tunrisefield, your choices, and the standards that apply to our store."
    >
      <div className="policy-index__notice">
        These policies are written specifically for tunrisefield and should be read together.
        Mandatory consumer and privacy rights in your location continue to apply. Questions can
        be sent to <EmailLink />.
      </div>
      <div className="policy-index__grid">
        {policyLinks.map(([path, label]) => (
          <Link className="policy-index__card" key={path} to={path} onClick={toTop}>
            <h2>{label}</h2>
            <p>{descriptions[path]}</p>
          </Link>
        ))}
      </div>
    </PolicyLayout>
  );
}

export default PolicyIndex;
